import {
    ComparatorPicker,
    ComparatorPickerBuilder,
    ComparatorPickerType,
    ComparisonOperator,
    Field,
    FieldType,
} from "../../vforms-model";
import { NumberFieldComponent } from "./number.component";
import { NumberFieldEditorComponent } from "./number-editor.component";
import { assign } from "lodash-es";
import { TextBox } from "../text-box/text-box";
import { ComparisonExpression } from "../../expression-settings/model";

export class NumberFieldType extends FieldType {
    static Id = "number";

    maxLength: number | undefined;

    minLength: number | undefined;

    constructor() {
        super();
        this.id = NumberFieldType.Id;
        this.icon = "mat_outline:exposure_zero";
        this.previewComponent = NumberFieldComponent;
        this.editorComponent = NumberFieldEditorComponent;
    }

    createField(): Field {
        return new NumberField(this);
    }

    supportedComparisonOperators(): ComparisonOperator[] {
        return [
            ...super.supportedComparisonOperators(),
            ComparisonOperator.Equal,
            ComparisonOperator.NotEqual,
            ComparisonOperator.LessThan,
            ComparisonOperator.EqualOrLessThan,
            ComparisonOperator.GreaterThan,
            ComparisonOperator.EqualOrGreaterThan,
        ];
    }

    evaluate(expression: ComparisonExpression, value: any): boolean {
        let numberValue: number | undefined = value ? (value as number) : undefined;
        let expressionNumberValue: number | undefined = expression.value ? (expression.value as number) : undefined;
        switch (expression.operator) {
            case ComparisonOperator.Equal:
                return numberValue && expressionNumberValue && expressionNumberValue === numberValue;
            case ComparisonOperator.NotEqual:
                return numberValue && expressionNumberValue && expressionNumberValue !== numberValue;
            case ComparisonOperator.LessThan:
                return numberValue && expressionNumberValue && numberValue < expressionNumberValue;
            case ComparisonOperator.EqualOrLessThan:
                return numberValue && expressionNumberValue && numberValue <= expressionNumberValue;
            case ComparisonOperator.GreaterThan:
                return numberValue && expressionNumberValue && numberValue > expressionNumberValue;
            case ComparisonOperator.EqualOrGreaterThan:
                return numberValue && expressionNumberValue && numberValue >= expressionNumberValue;
        }

        return super.evaluate(expression, value);
    }
}

export class NumberField extends TextBox {
    min: number;

    max: number;

    toJson() {
        const definition = super.toJson();
        assign(definition, {
            min: this.min,
            max: this.max,
        });
        return definition;
    }
}

export class NumberComparatorPickerBuilder extends ComparatorPickerBuilder {
    build(comparisonExpression: ComparisonExpression): ComparatorPicker {
        if (
            comparisonExpression.operator === ComparisonOperator.NotEmpty ||
            comparisonExpression.operator === ComparisonOperator.Empty
        ) {
            return new ComparatorPicker(ComparatorPickerType.None);
        }

        return new ComparatorPicker(ComparatorPickerType.Number);
    }
}
